import { useAuth0 } from "@auth0/auth0-react";
import { InputField } from "components/InputField";
import InfoTooltip from "components/InfoTooltip";
import "components/SendLetter/sendLetter.scss";
import EmailsList from "components/ShareDocuments/Emails/EmailsList";
import CommunicationService from "Lib/API/Communication/index";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  setCardContent,
  setDataAfterCreatedCampaign,
} from "services/api/communication";
import { getRandColor } from "utils/emailRandomColors";
import { fromEtPickerDate } from "helper/dateFormat";
import { Footer } from "../Footer/Footer";
import { SubjectWrapper, ToWrapper } from "./Theme";
export const SendEmail = ({
  formik,
  setViewTemplate,
  setActiveStep,
  step,
  setCardName,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const { selectedTemplate } = useSelector((state) => state.communication);
  const [savedEmails, setSavedEmails] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templatesOptions, setTemplatesOptions] = useState([]);
  const { campaignEditData } = useSelector((state) => state.communication);

  const dispatch = useDispatch();
  const selectedAudiences = useSelector(
    (state) => state.communication.selectedAudienceRows
  );
  const {fromSelectedStep,cardContent} = useSelector(
    (state) => state.communication
  );
  const [createCampaignLoading, setCreateCampaignLoading] = useState(false);
  const [createCampaignDraftLoading, setCreateCampaignDraftLoading] =
    useState(false);
    console.log('cardContent', cardContent)
  const audienceNames =
    Object.keys(campaignEditData)?.length > 0
      ? campaignEditData?.audience?.map((val) => val.name)
      : selectedAudiences?.map((val) => val.name);
  const buttons = [
    {
      name: "Previous",
      action: () => {
        if (fromSelectedStep) {
          setActiveStep(0);
          setViewTemplate(true);
        } else {
          setActiveStep(step);
        }
      },
      isDisabled: false,
      type: "secondary",
      marginRight: "42rem",
      width: "100px",
      variant : "primary-outline"
    },
    {
      name: "Save as a draft",
      action: () => {
        createCampaign(true);
      },
      isDisabled: !formik.values?.subject,
      type: "secondary",
      loading: createCampaignDraftLoading,
      width: "150px",
      variant : "primary"
    },
    {
      name: formik.values?.scheduledCampaign ? "Send as scheduled" : "Send",
      action: () => {
        createCampaign(false);
      },
      isDisabled: !formik.values?.subject,
      type: "primary",
      loading: createCampaignLoading,
      width: formik.values?.scheduledCampaign ? "150px" : "100px",
      variant : "primary"
    },
  ];

  const getTemplatesHandler = async () => {
    const token = await getAccessTokenSilently();
    const data = {
      filter: {
        templateSource: "user",
      },
    };
    try {
      const response = await FinancialSetting.getTemplatesList(token, data);
      setTemplates(response?.result);
      setTemplatesOptions(
        response?.result?.map((item) => {
          return {
            label: item?.title,
            value: item?._id,
          };
        })
      );
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
    }
  };
  const createCampaign = async (isDraft) => {
    isDraft
      ? setCreateCampaignDraftLoading(true)
      : setCreateCampaignLoading(true);
    const token = await getAccessTokenSilently();
    let data;
    if (Object.keys(campaignEditData).length > 0) {
      data = {
        id: campaignEditData?._id,
        isDraft: isDraft,
        data: {
          campaignName: formik.values?.campainName,
          campaignType: "email",
          template: campaignEditData?.template?._id,
          audience: campaignEditData?.audience?.map((val) => val._id),
          isScheduled: formik.values?.scheduledCampaign,
          subject: formik.values?.subject,
          scheduled: {
            date: fromEtPickerDate(formik.values?.emailDate)?.toISOString() ?? null,
          },
        },
      };
    } else {
      data = {
        isDraft: isDraft,
        data: {
          campaignName: formik.values?.campainName,
          campaignType: "email",
          template: selectedTemplate?._id,
          audience: selectedAudiences?.map((val) => val._id),
          isScheduled: formik.values?.scheduledCampaign,
          subject: formik.values?.subject,
          scheduled: {
            date: fromEtPickerDate(formik.values?.emailDate)?.toISOString() ?? null,
          },
        },
      };
    }

    try {
      const response =
        Object.keys(campaignEditData).length > 0
          ? await CommunicationService.updateCampaign(data, token)
          : await CommunicationService.createCampaign(data, token);
      isDraft
        ? setCreateCampaignDraftLoading(false)
        : setCreateCampaignLoading(false);
      Object.keys(campaignEditData).length > 0
        ? toastr.success("Success", "Campaign updated sucessfully")
        : toastr.success("Success", "Campaign created sucessfully");
      dispatch(setDataAfterCreatedCampaign(response?.result));
      dispatch(setCardContent("Done"));
      setCardName && setCardName("Email");
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      isDraft
        ? setCreateCampaignDraftLoading(false)
        : setCreateCampaignLoading(false);
    }
  };
  const displayInitialEmailsHandler = async () => {
    const uniqueEmails = [...new Set(audienceNames)]; // Remove duplicates using Set
    const emails = uniqueEmails.map((item) => ({
      email: item,
      type: "to",
      image: item.charAt(0).toUpperCase(),
      color: getRandColor(),
    }));
    setSavedEmails((prev) => [...prev, ...emails]);
  };

  useEffect(() => {
    getTemplatesHandler();
    displayInitialEmailsHandler();
  }, []);

  const createMarkup = () => {
    return {
      __html:
        selectedTemplate?.htmlContent ||
        campaignEditData?.template?.htmlContent,
    };
  };
  const addEmailsHandler = ({ type, email }) => {
    if (savedEmails?.some((savedEmail) => savedEmail.email === email)) return;
    setSavedEmails((prev) => [
      ...prev,
      {
        type,
        email,
        image: email.charAt(0).toUpperCase(),
        color: getRandColor(),
      },
    ]);
  };
  return (
    <div
      className="send-letter"
      style={{ width: "100%", position: "relative", minHeight: "517px" }}
    >
      <div className="send-letter__content">
        <div style={{ overflow: "hidden" }}>
          <ToWrapper>
            <span>To :</span>
            <EmailsList
              setSavedEmails={setSavedEmails}
              addEmailsHandler={addEmailsHandler}
              list={savedEmails}
              // removeEmail={removeEmailHandler}
              className={"test-email-content"}
              disabledAdding={true}
            />
          </ToWrapper>
          <br />

          <SubjectWrapper>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Subject <span style={{ color: 'red' }}>*</span></span>
              <InfoTooltip text="Choose Save as a draft to keep working on this campaign later, or Send / Send as scheduled to deliver it now or at the scheduled date/time above." style={{ marginLeft: '6px' }} />
            </div>
            <InputField
              type="text"
              title="none"
              mandatory
              formStyle={{ marginBottom: 0 }}
              {...{
                formik,
                name: "subject",
                placeholder: "Subject",
                value: formik?.values?.subject,
              }}
              handleChange={(e) => {
                formik.setFieldValue("subject", e?.target?.value);
              }}
              inputClassName="donation__input"
            />
          </SubjectWrapper>
          <div dangerouslySetInnerHTML={createMarkup()} />
        </div>
        <br />
        <Footer
          buttons={buttons}
          type="My template"
          Wrapperstyle={{
            width: "100%",
            justifyContent: "center",
            marginButton: "10px",
            position: "absolute",
            bottom: "10px",
            left: "-8rem",
          }}
        />
        <br />
      </div>
    </div>
  );
};
